import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const RegistersReportByPayementMethods = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  let navigate = useNavigate();
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectepaymentMethods, setSelectedPaymentMethods] = useState({
    paymentMethod: "All",
    paymentMethodId: 0,
  });
  const [classicView, setClassicView] = useState(true);

  console.log(paymentMethods, "paymentMethods");

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data?.ResponseData, "rescheck");
        const filteredMethods = res.data?.ResponseData.filter(
          (item) => item.receivepayment === 1
        ).map((item) => ({ label: item.Paymenttypename, value: item.ID }));

        setPaymentMethods(filteredMethods);
      })
      .catch((err) => console.log(err));
    setLoading(false);
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handlePaymentMethodChnage = (event) => {
    if (event) {
      setSelectedPaymentMethods({
        paymentMethod: event.label, // Store the name
        paymentMethodId: event.value, // Store the ID
      });
    } else {
      // If cleared, reset to default values
      setSelectedPaymentMethods({
        paymentMethod: "All",
        paymentMethodId: 0,
      });
    }
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/registerreportbypaymentmethods?paymentMethodId=${selectepaymentMethods.paymentMethodId}&paymentMethod=${selectepaymentMethods.paymentMethod}&locationid=${locationid}&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const data = res.data.ResponseData;
          const FilterData = data?.map((el) => ({
            ...el,
            OpenAmount: Number(el?.OpenAmount),
            CloseAmount: Number(el?.CloseAmount) || 0,
            Sales: Number(el?.Sales) || 0,
            TotalAdditions: Number(el?.TotalAdditions) || 0,
            TotalSubtractions: Number(el?.TotalSubtractions) || 0,
          }));
          setResponseData(FilterData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const columns = useMemo(() => [
    {
      header: "Register Log ID",
      accessorKey: "EmployeeRegisterId",
    },
    {
      header: "Register Employee",
      accessorKey: "Employee",
    },
    {
      header: "Details",
      Cell: ({ row }) => (
        <>
          <Box
            component="span"
            sx={(theme) => ({
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight: "700",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
            })}
            onClick={() =>
              navigate(
                `/register_log_details/${row.original.EmployeeRegisterId}`
              )
            }
          >
            Details
          </Box>
        </>
      ),
    },
    {
      header: "Open Amount",
      accessorKey: "OpenAmount",
      Cell: ({ row }) => {
        const openAmount = row?.original?.OpenAmount;
        return (
          <div>
            {CurrencySymbols(
              Number(openAmount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const allowedGroupingColumns = [
          "MasterRegister",
          "Employee",
          "EmployeeRegisterId",
        ]; // Allowed grouping columns
        const groupingColumnId = allowedGroupingColumns.includes(
          cell.row.groupingColumnId
        )
          ? cell.row.groupingColumnId
          : null; // Return null if it's an unallowed grouping column

        if (!groupingColumnId) return null; // Do not render for unwanted groupings

        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Close Amount",
      accessorKey: "CloseAmount",
      Cell: ({ row }) => {
        const closeamt = row?.original?.CloseAmount;
        return (
          <div>
            {CurrencySymbols(
              Number(closeamt),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const allowedGroupingColumns = [
          "MasterRegister",
          "Employee",
          "EmployeeRegisterId",
        ]; // Allowed grouping columns
        const groupingColumnId = allowedGroupingColumns.includes(
          cell.row.groupingColumnId
        )
          ? cell.row.groupingColumnId
          : null; // Return null if it's an unallowed grouping column

        if (!groupingColumnId) return null; // Do not render for unwanted groupings

        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Total Sales",
      accessorKey: "Sales",
      Cell: ({ row }) => {
        const saleamount = row?.original?.Sales;
        return (
          <div>
            {CurrencySymbols(
              Number(saleamount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const allowedGroupingColumns = [
          "MasterRegister",
          "Employee",
          "EmployeeRegisterId",
        ]; // Allowed grouping columns
        const groupingColumnId = allowedGroupingColumns.includes(
          cell.row.groupingColumnId
        )
          ? cell.row.groupingColumnId
          : null; // Return null if it's an unallowed grouping column

        if (!groupingColumnId) return null; // Do not render for unwanted groupings

        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Total Additions",
      accessorKey: "TotalAdditions",
      Cell: ({ row }) => {
        const addamount = row?.original?.TotalAdditions;
        return (
          <div>
            {CurrencySymbols(
              Number(addamount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const allowedGroupingColumns = [
          "MasterRegister",
          "Employee",
          "EmployeeRegisterId",
        ]; // Allowed grouping columns
        const groupingColumnId = allowedGroupingColumns.includes(
          cell.row.groupingColumnId
        )
          ? cell.row.groupingColumnId
          : null; // Return null if it's an unallowed grouping column

        if (!groupingColumnId) return null; // Do not render for unwanted groupings

        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Total Subtractions",
      accessorKey: "TotalSubtractions",
      Cell: ({ row }) => {
        const subamount = row?.original?.TotalSubtractions;

        return (
          <div>
            {CurrencySymbols(
              Number(subamount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const allowedGroupingColumns = [
          "MasterRegister",
          "Employee",
          "EmployeeRegisterId",
        ]; // Allowed grouping columns
        const groupingColumnId = allowedGroupingColumns.includes(
          cell.row.groupingColumnId
        )
          ? cell.row.groupingColumnId
          : null; // Return null if it's an unallowed grouping column

        if (!groupingColumnId) return null; // Do not render for unwanted groupings

        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Master Register",
      accessorKey: "MasterRegister",
    },
    {
      header: "Location",
      accessorKey: "Location",
    },
    {
      header: "Status",
      accessorKey: "Status",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
    },
  ]);

  const Classiccolumns = [
    {
      title: "Register Log ID",
      field: "EmployeeRegisterId",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Register Employee",
      field: "Employee",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Details",
      field: "EmployeeRegisterId",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const id = cell.getValue();
        const span = document.createElement("span");
        span.textContent = "Details";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.fontWeight = "700";
        span.addEventListener("click", () => {
          window.open(`/register_log_details/${id}`, "_blank");
        });
        return span;
      },
    },
    {
      title: "Open Amount",
      field: "OpenAmount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Close Amount",
      field: "CloseAmount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total Sales",
      field: "Sales",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total Additions",
      field: "TotalAdditions",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total Subtractions",
      field: "TotalSubtractions",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },

    {
      title: "Master Register",
      field: "MasterRegister",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },

    {
      title: "Location",
      field: "Location",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Status",
      field: "Status",
      headerFilter: "input",
      defaultVisible: true,
    },

    {
      title: "Payment Method",
      field: "PaymentMethod",
      headerFilter: "input",
      defaultVisible: true,
    },
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Registers Report ment Methods
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4 ">
                <div className="row">
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-12 form-label p-lg-medium">
                Payment Methods
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={paymentMethods}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={paymentMethods.find(
                      (e) => e.value === selectepaymentMethods.paymentMethodId
                    )}
                    onChange={(event) => {
                      handlePaymentMethodChnage(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary pull-right"
                style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Submit
              </button>
            </div>
          </div>

          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Registers By Payement Methods
                    </p>
                    <div className="row mb-2 p-regular">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "Classic View" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}

                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      // Groupvalue={[]}
                      Groupvalue={["Employee"]}
                      Reportname={"Registers By Payement Methods"}
                      frozenRowvalue={0}
                      layout={"fitDataFill"}
                      Onrefresh={() => apicall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Registers By Payement Methods"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={[
                        "MasterRegister",
                        "Employee",
                        "EmployeeRegisterId",
                        "PaymentMethod",
                      ]}
                      columnsVisibility={{}}
                      enableRowSelection={false}
                      enableExpandAll={true}
                      enableExpanding={true}
                      expanded={true}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RegistersReportByPayementMethods;
